(function() {
    window.c24.lp.ac.mpdv = {

        init: function() {

            window.c24.lp.ac.addDefaultQtips('mpdv');

            window.c24.lp.ac.addQTip({
                acType: 'mpdv',
                hoverElement: '.mod24ac .checkbox',
                toolTipChild: '.js24Tooltip',
                arrowPosition: 'top center',
                parentPosition: 'bottom center',
                hideDelay: 0,
            });

            $('.mod24ac.mpdv form').on('submit', function(e) {
                const form = $(e.target);
                const selectValue = $('select[name=vehicleType]', form).val();
                const specialTarget = $('option:selected', form).data('target');

                $('input[type=hidden][data-enable-for]', form).attr('disabled', true);
                $('input[type=hidden][data-enable-for=' + selectValue + ']', form).attr('disabled', false);

                if (specialTarget) {
                    $(this).attr('action', specialTarget);
                } else {
                    $(this).attr('action', form.data('default'));
                }
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.mpdv.init();
    });
})();
